import * as React from 'react';
import {Checkbox, styled} from "@mui/material";

export const BlackDisabledCheckBox = styled(Checkbox)({
    "& .Mui-disabled": { color: "#656565", },
});
